import React from 'react';
import PropTypes from 'prop-types';
import './UnavailablePage.scss';

export const UnavailablePage = ({ title, message }) => {
  return (
    <div className="unavailablePageContainer">
      <h2>{title}</h2>
      {message && <p>{message}</p>}
    </div>
  );
};

UnavailablePage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string
};
